import { useState } from 'react';
import { Share2, Copy, Check, MessageCircle, Facebook } from 'lucide-react';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { shareLinks } from '@/lib/seo';

const XIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" /></svg>
);

/** Compartilhamento da página específica (não da home). */
export const ShareDialog = ({ path, title, testId = 'share-button', variant = 'secondary' }) => {
  const [copied, setCopied] = useState(false);
  const url = `${window.location.origin}${path}`;
  const links = shareLinks(url, title);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success('Link copiado');
      setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      toast.error('Não foi possível copiar automaticamente. Selecione o link e copie manualmente.');
    }
  };
  const items = [
    { id: 'whatsapp', label: 'WhatsApp', icon: MessageCircle, href: links.whatsapp },
    { id: 'x', label: 'X', icon: XIcon, href: links.x },
    { id: 'facebook', label: 'Facebook', icon: Facebook, href: links.facebook },
  ];
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant={variant} className="border border-white/10" data-testid={testId}>
          <Share2 /> Compartilhar
        </Button>
      </DialogTrigger>
      <DialogContent className="border-white/10 bg-[#0b0f16] sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display">Compartilhar</DialogTitle>
          <DialogDescription className="line-clamp-2">{title}</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-3 gap-2">
          {items.map(({ id, label, icon: Icon, href }) => (
            <a key={id} href={href} target="_blank" rel="noopener noreferrer" data-testid={`share-${id}-link`} className="flex flex-col items-center gap-2 rounded-lg border border-white/10 bg-white/[0.03] px-3 py-4 text-xs transition-colors hover:border-cyan-300/40 hover:bg-white/[0.06]">
              <Icon className="h-5 w-5 text-primary" /> {label}
            </a>
          ))}
        </div>
        <div className="flex gap-2">
          <Input readOnly value={url} aria-label="Link da página" className="font-mono text-xs" data-testid="share-url-input" onFocus={(e) => e.target.select()} />
          <Button onClick={copy} data-testid="share-copy-button" className="btn-glow">
            {copied ? <Check /> : <Copy />} {copied ? 'Copiado' : 'Copiar'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
